export const SUPPLI_SHARE_LINK = 'mysuppli.ubpages.com';